import React from 'react';
import classNames from 'classnames';
import styles from '@buyside/components/presentation/Twitter/twitterStyles.scss';

export const charLimit = 280;
export const warningThreshold = 260;

const WordCounter: React.FC<{ weightedLength: number }> = ({ weightedLength }) => {
  const diameter = weightedLength < warningThreshold ? 30 : 45;
  const circumference = Math.PI * diameter;

  return (
    <div
      className={classNames(styles.countdownCircle, {
        [styles.warning]: weightedLength >= warningThreshold,
        [styles.invalid]: weightedLength > charLimit
      })}
      data-testid="countdownCircle"
    >
      {weightedLength >= warningThreshold && (
        <div
          dir="auto"
          aria-atomic="true"
          aria-live="polite"
          data-testid="screenReaderContent"
          className={styles.screenReaderContent}
        >
          {weightedLength <= charLimit
            ? `${charLimit - weightedLength} characters remaining`
            : `You have exceeded the character limit by ${weightedLength - charLimit}`}
        </div>
      )}
      <div
        role="progressbar"
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={Math.min(Math.floor((weightedLength / charLimit) * 100), 100)}
        className={classNames(styles.progressBar, {
          [styles.hiddenProgressBar]: weightedLength > 289
        })}
      >
        <div className={styles.svgContainer}>
          <svg
            height="100%"
            viewBox={`0 0 ${diameter} ${diameter}`}
            width="100%"
            className={styles.progressSVG}
          >
            <circle
              cx="50%"
              cy="50%"
              fill="none"
              r={diameter / 2}
              stroke="#EFF3F4"
              strokeWidth="3px"
            ></circle>
            <circle
              className={styles.fillCircle}
              cx="50%"
              cy="50%"
              fill="none"
              r={diameter / 2}
              strokeDasharray={circumference}
              strokeDashoffset={Math.max(
                circumference - (weightedLength / charLimit) * circumference,
                0
              )}
              strokeLinecap="round"
              strokeWidth="3px"
            ></circle>
          </svg>
        </div>
      </div>
      <div className={styles.countdownTextContainer}>
        <div className={styles.countdownText}>{charLimit - weightedLength}</div>
      </div>
    </div>
  );
};

export default WordCounter;
